const ProfileAvatar = ({ name, imageUrl }) => {
  const getInitial = (fullName) => {
    if (!fullName) return "?";
    return fullName.charAt(0).toUpperCase();
  };

  return (
    <div>
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={name}
          style={{
            width: 50,
            height: 50,
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      ) : (
        <div
          style={{
            width: 50,
            height: 50,
            borderRadius: "50%",
            backgroundColor: "#007",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            fontSize: "1.5rem",
            fontWeight: "bold",
          }}
        >
          {getInitial(name)}
        </div>
      )}
    </div>
  );
};

export default ProfileAvatar;
